import { useEffect, useState } from "react";
import { api, getSubmitterToken, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

/**
 * Invited lovers must tick the publication consent (box 2) before they can
 * edit. Owners and pros pass straight through; visitors without a session
 * (magic-link open flow) are not gated here.
 */
export default function CoeditorGate({ eventId, children }) {
  const [state, setState] = useState("loading"); // loading | gate | ok
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let live = true;
    (async () => {
      if (!getSubmitterToken()) { setState("ok"); return; }
      try {
        const { data } = await api.get(`/events/${eventId}/summary`);
        if (live) setState(data.needs_coeditor_consent ? "gate" : "ok");
      } catch {
        if (live) setState("ok");
      }
    })();
    return () => { live = false; };
  }, [eventId]);

  const confirm = async () => {
    if (!agree) return toast.error("Please tick the box to continue.");
    setBusy(true);
    try {
      await api.post(`/events/${eventId}/coeditor-consent`, { agree: true });
      setState("ok");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  if (state === "loading") {
    return <div className="py-16 text-center text-[#5c5852] text-sm">Loading…</div>;
  }
  if (state === "gate") {
    return (
      <div className="w-full max-w-xl mx-auto px-6 sm:px-10 pt-16 pb-24" data-testid="coeditor-consent-gate">
        <p className="btw-step-label mb-3">One quick thing</p>
        <h1 className="text-3xl font-bold leading-tight mb-6">Before you edit</h1>
        <div className="btw-section">
          <label className="flex items-start gap-3 text-sm text-black cursor-pointer">
            <input
              type="checkbox"
              data-testid="coeditor-agree"
              className="btw-check mt-0.5"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            />
            <span>
              <strong>Everyone named as a lover in this submission agrees</strong> to
              our story, names and photos being published, including details about
              our relationship.
            </span>
          </label>
        </div>
        <button onClick={confirm} disabled={busy || !agree} data-testid="coeditor-confirm" className="btw-btn mt-6">
          {busy ? "Saving…" : "Agree and continue"}
        </button>
      </div>
    );
  }
  return children;
}
